import { Component } from '@angular/core';
import { IonicPage, NavController, Events } from 'ionic-angular';

import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { TabsPage } from '../tabs/tabs';
import { LoginPage } from '../login/login';
import { AuthProvider } from '../../providers/auth/auth.provider';
import { CguPage } from '../cgu/cgu';



@IonicPage()
@Component({
  selector: 'page-register',
  templateUrl: 'register.html'
})
export class RegisterPage {

  registerForm: FormGroup;
  errorMessage: string = '';
  successMessage: string = '';

  constructor(
    public navCtrl: NavController,
    public authProvider: AuthProvider,
    private events:Events,
    public formBuilder: FormBuilder
  ) {}

  ionViewWillLoad(){
    this.registerForm = this.formBuilder.group({
      email: new FormControl(),
      password: new FormControl()
    });
  }

  goToCGU(){
    this.navCtrl.push(CguPage);
  }
  
  tryRegister(value){
    this.authProvider.doRegister(value)
     .then(res => {
       this.errorMessage = "";
       this.successMessage = "Your account has been created.";
       this.doLogin(value);
     }, err => {
       this.errorMessage = err.message;
       this.successMessage = "";
     })
  }
  doLogin(data){

    this.authProvider.doLogin(data)
    .then(res => {
      console.log(res);
      this.events.publish('user:login');
      this.navCtrl.pop();
    }, err => {
      console.log(err);
      this.errorMessage = err.message;
    })
  }
  tryFacebookLogin(){
    this.authProvider.doFacebookLogin()
    .then((res) => {
      this.navCtrl.setRoot(TabsPage);
    }, (err) => {
      this.errorMessage = err.message;
    });
  }

  tryGoogleLogin(){
    this.authProvider.doGoogleLogin()
    .then((res) => {
      this.navCtrl.setRoot(TabsPage);
    }, (err) => {
      this.errorMessage = err.message;
    });
  }

  tryTwitterLogin(){
    this.authProvider.doTwitterLogin()
    .then((res) => {
      this.navCtrl.setRoot(TabsPage);
    }, (err) => {
      this.errorMessage = err.message;
    });
  }

  goLoginPage(){
    this.navCtrl.push(LoginPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts